import { render } from "./SettingsOverlay.vue?vue&type=template&id=4f395575&scoped=true"
import script from "./SettingsOverlay.vue?vue&type=script&lang=js"
export * from "./SettingsOverlay.vue?vue&type=script&lang=js"

import "./SettingsOverlay.vue?vue&type=style&index=0&id=4f395575&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f395575"]])

export default __exports__